import t, { useRef as n, useEffect as e, useState as r, useLayoutEffect as i, useCallback as o } from "react";
var _s = function s() {
  return (_s = Object.assign || function (t) {
    for (var n, e = 1, r = arguments.length; e < r; e++) for (var i in n = arguments[e]) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    return t;
  }).apply(this, arguments);
};
function a(t, n) {
  void 0 === n && (n = {});
  var e = n.insertAt;
  if (t && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      i = document.createElement("style");
    i.type = "text/css", "top" === e && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i), i.styleSheet ? i.styleSheet.cssText = t : i.appendChild(document.createTextNode(t));
  }
}
var l = "styles-module_carousel-base__3keqD",
  u = "styles-module_item-provider__YgMwz",
  c = "styles-module_item-container__a8zaY",
  f = "styles-module_item-tracker__3bypy",
  d = "styles-module_carousel-arrow__26sRw";
a(".styles-module_carousel-base__3keqD {\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\toutline: none;\n\tposition: relative;\n}\n\n.styles-module_item-provider__YgMwz {\n\toverflow: hidden;\n\twidth: 100%;\n\tcursor: pointer;\n}\n\n.styles-module_item-container__a8zaY img {\n\t-webkit-user-select: none;\n\t        user-select: none;\n\t-webkit-user-drag: none;\n}\n\n.styles-module_item-tracker__3bypy {\n\theight: 100%;\n\tdisplay: flex;\n}\n\n.styles-module_carousel-arrow__26sRw {\n\tz-index: 1;\n}\n");
var h,
  m = function m(n) {
    return t.createElement("button", {
      className: d,
      onClick: n.onClick,
      "data-direction": n.direction
    });
  };
!function (t) {
  t[t.Right = -1] = "Right", t[t.Left = 1] = "Left";
}(h || (h = {}));
var g = function () {
    function t(t, n) {
      this.arr = t, this.currentIndex = n;
    }
    return t.prototype.next = function () {
      var t = this.currentIndex,
        n = this.arr;
      return this.currentIndex = t < n.length - 1 ? t + 1 : 0, this.current();
    }, t.prototype.prev = function () {
      var t = this.currentIndex,
        n = this.arr;
      return this.currentIndex = t > 0 && t < n.length ? t - 1 : n.length - 1, this.current();
    }, t.prototype.current = function () {
      return this.arr[this.currentIndex];
    }, t;
  }(),
  v = function v(t, n, e) {
    return e * t * n;
  },
  p = function p(t) {
    var n = t.itemCount,
      e = t.itemsToShow,
      r = t.infinite,
      i = t.current,
      o = t.hideArrows;
    if (void 0 !== o && o) return {
      left: !1,
      right: !1
    };
    var s = n > e;
    return r ? {
      left: s,
      right: s
    } : {
      left: s && 0 !== i,
      right: s && i + e < n
    };
  },
  w = function w(t, n, e) {
    if (!e) return t;
    for (var r = Array.from(t), i = new g(t, 0), o = 0; o < n; o++) r.unshift(i.prev());
    return r;
  };
function y(t) {
  return t.nativeEvent instanceof MouseEvent ? t.nativeEvent.pageX : t.nativeEvent instanceof TouchEvent ? t.nativeEvent.changedTouches[0].pageX : 0;
}
function _(t, n, e, r, i) {
  if (e && e.length < n.length) return w(n, r, i);
  var o = t.map(function (t) {
    return n.find(function (n) {
      return t.key === n.key;
    });
  });
  return o.some(function (t) {
    return void 0 === t;
  }) ? w(n, r, i) : o;
}
var k = function k(t) {
    var n = r("undefined" == typeof window ? 0 : window.innerWidth),
      e = n[0],
      o = n[1];
    i(function () {
      var n = function n() {
        var n = e - window.innerWidth;
        o(window.innerWidth), t(n);
      };
      return window.addEventListener("resize", n), function () {
        return window.removeEventListener("resize", n);
      };
    }, []);
  },
  C = function C(n) {
    var e = r(200),
      i = e[0],
      a = e[1],
      l = o(function (t) {
        if (null !== t) {
          var e = t.getBoundingClientRect().width / n.show;
          a(e), n.widthCallBack(e);
        }
      }, [i]);
    n.responsive && k(function (t) {
      a(i - t);
    });
    var d = r({
        initial: n.transform,
        start: 0,
        isDown: !1,
        drag: 0,
        finished: !0,
        pointers: !0
      }),
      m = d[0],
      g = d[1],
      v = function v(t) {
        t.persist(), g(_s(_s({}, m), {
          isDown: !0,
          start: y(t),
          initial: n.transform,
          finished: !1
        }));
      },
      p = function p(t) {
        if (t.persist(), !m.finished) {
          if (Math.abs(m.drag) < i * n.swipeOn) return n.dragCallback(n.transform), g({
            initial: n.transform,
            start: 0,
            isDown: !1,
            drag: 0,
            finished: !0,
            pointers: !0
          });
          n.slideCallback(m.drag > 0 ? h.Right : h.Left), g(_s(_s({}, m), {
            drag: 0,
            isDown: !1,
            finished: !0,
            pointers: !0
          }));
        }
      },
      w = function w(t) {
        if (t.persist(), m.isDown) {
          var e = y(t);
          g(_s(_s({}, m), {
            drag: m.start - e,
            pointers: Math.abs(m.start - e) < n.triggerClickOn
          }));
        }
      },
      _ = n.swiping ? {
        onTouchCancel: p,
        onTouchEnd: p,
        onTouchMove: w,
        onTouchStart: v,
        onMouseDown: v,
        onMouseLeave: p,
        onMouseUp: p,
        onMouseMove: w
      } : {};
    return t.createElement("div", {
      ref: l,
      className: u
    }, t.createElement("div", _s({
      "data-testid": "trackList"
    }, _, {
      className: f,
      style: {
        transform: "translateX(" + (n.transform - m.drag) + "px)",
        transition: "transform " + n.transition + "s ease 0s",
        width: i * n.items.length
      }
    }), n.items.map(function (n, e) {
      return t.createElement("div", {
        key: e,
        style: {
          width: i,
          pointerEvents: m.pointers ? "all" : "none"
        },
        className: c
      }, n);
    })));
  },
  b = {
    children: [],
    show: 1,
    slide: 1,
    transition: .5,
    swiping: !1,
    swipeOn: 1,
    responsive: !1,
    infinite: !0,
    className: "",
    useArrowKeys: !1,
    a11y: {},
    dynamic: !1,
    paginationCallback: null,
    pageCount: 0,
    rightArrow: null,
    leftArrow: null,
    autoSwipe: null,
    navigation: null,
    triggerClickOn: Number.MIN_SAFE_INTEGER,
    hideArrows: !1,
    onLeftArrowClick: function onLeftArrowClick() {
      return null;
    },
    onRightArrowClick: function onRightArrowClick() {
      return null;
    }
  },
  L = "styles-module_carousel-navigation__1g_vs";
a(".styles-module_carousel-navigation__1g_vs {\n\tdisplay: flex;\n\tposition: absolute;\n\tbottom: 0;\n}\n");
var E = function E(n) {
    var e = n.items,
      r = n.current,
      i = n.onClick,
      o = n.factory;
    return t.createElement("div", {
      className: L
    }, e.map(function (n, e) {
      return t.createElement("div", {
        onMouseOver: function onMouseOver() {
          return i(e);
        },
        key: e
      }, o(r === e));
    }));
  },
  x = function x(i) {
    var o,
      a,
      u,
      c,
      f = _s(_s({}, b), i),
      d = w(f.children, f.navigation ? f.children.length - 1 : f.slide, f.infinite),
      y = r(d),
      k = y[0],
      L = y[1],
      x = n(d),
      R = r(0),
      A = R[0],
      M = R[1],
      T = r({
        transform: 0,
        transition: 0,
        isSliding: !1
      }),
      S = T[0],
      N = T[1],
      I = r(0),
      D = I[0],
      O = I[1],
      W = r(p({
        itemCount: f.children.length,
        itemsToShow: f.show,
        infinite: f.infinite,
        current: D,
        hideArrows: f.hideArrows
      })),
      z = W[0],
      X = W[1],
      B = (u = i.children, c = n(), e(function () {
        c.current = u;
      }), c.current),
      q = r(0),
      K = q[0],
      Y = q[1],
      j = n(!1),
      F = n(null),
      P = n(),
      U = "function" == typeof f.navigation;
    f.dynamic && e(function () {
      var t = _(x.current, f.children, B, f.slide, f.infinite);
      L(t), x.current = t, K < f.pageCount && B && (null == B ? void 0 : B.length) < f.children.length && (H(h.Right), Y(K + 1));
    }, [f.children]), e(function () {
      G();
    }, []);
    var G = function G() {
        clearTimeout(P.current), F && "number" == typeof f.autoSwipe && f.autoSwipe > f.transition && (P.current = setTimeout(function () {
          F.current && F.current.click();
        }, f.autoSwipe));
      },
      H = function H(t, n) {
        if (!(S.isSliding || t === h.Right && !z.right || t === h.Left && !z.left)) {
          if (f.paginationCallback && t === h.Right && K < f.pageCount - 1 && !j.current) return j.current = !0, void f.paginationCallback(t);
          var e = f.children,
            r = function (t, n, e, r) {
              var i = t - r * n;
              return i < 0 ? e + i : e <= i ? i - e : i;
            }(D, f.slide, e.length, t),
            i = "number" == typeof n ? n - D : -1 * t,
            o = f.infinite ? U ? function (t, n, e, r, i, o) {
              var s = function (t, n, e) {
                  var r = t + n >= e.length ? t + n - e.length : t + n;
                  return r < 0 ? e.length + r : r;
                }(e, i, t),
                a = Math.floor(n.length / 2),
                l = new g(t, s),
                u = Array.from(n);
              switch (+o) {
                case h.Left:
                  for (var c = 0; c < a; c++) {
                    var f = a - (Math.abs(i) + c) - r;
                    (f < 0 || !u[f]) && u.unshift(l.current()), l.prev();
                  }
                  break;
                case h.Right:
                  for (c = 0; c < a; c++) u[a + i + c + r] || u.push(l.current()), l.next();
              }
              return u;
            }(e, k, r, f.show, i, t) : function (t, n, e, r, i, o) {
              var s = new g(t, e),
                a = Array.from(n);
              switch (+o) {
                case h.Left:
                  for (var l = i; l >= 0; l--) (i - l < 0 || !a[l - i]) && a.unshift(s.current()), s.prev();
                  break;
                case h.Right:
                  for (l = 0; l < r + i; l++) a[2 * i + l] || a.push(s.current()), s.next();
              }
              return a;
            }(e, k, r, f.show, f.slide, t) : k;
          f.infinite && t === h.Right && (L(o), x.current = o), N({
            transform: S.transform + Math.abs(i) * v(A, f.slide, t),
            transition: f.transition,
            isSliding: !0
          }), O(U && "number" == typeof n ? n : r), X(p({
            itemCount: e.length,
            itemsToShow: f.show,
            infinite: f.infinite,
            current: r,
            hideArrows: f.hideArrows
          })), setTimeout(function () {
            if (f.infinite) {
              var e = U ? function (t, n, e) {
                return e === h.Left ? t.slice(0, n) : t.slice(n);
              }(t === h.Right ? x.current : o, function (t, n, e, r) {
                return "number" == typeof t ? r === h.Right ? t - n + 1 : e : -1 * r;
              }(n, r, i, t), t) : function (t, n, e) {
                return e === h.Left ? t.slice(0, -1 * n) : t.slice(n);
              }(t === h.Right ? x.current : o, f.slide, t);
              L(e), x.current = e;
            }
            N({
              transform: f.infinite ? v(A, f.navigation ? f.children.length - 1 : f.slide, h.Right) : S.transform + v(A, f.slide, t),
              transition: 0,
              isSliding: !1
            }), G();
          }, 1e3 * f.transition), j.current = !1;
        }
      };
    return t.createElement("div", _s({}, f.a11y, {
      "data-testid": "carousel",
      tabIndex: 0
    }, f.useArrowKeys ? {
      onKeyDown: function onKeyDown(t) {
        37 === t.keyCode ? H(h.Left) : 39 === t.keyCode && H(h.Right);
      }
    } : {}, {
      className: l + " " + f.className
    }), z.left && t.createElement("div", {
      onClick: function onClick() {
        H(h.Left), f.onLeftArrowClick && f.onLeftArrowClick();
      }
    }, null !== (o = f.leftArrow) && void 0 !== o ? o : t.createElement(m, {
      direction: "left"
    })), t.createElement(C, _s({}, f, {
      transition: S.transition,
      items: x.current,
      transform: S.transform,
      slideCallback: function slideCallback(t) {
        H(t);
      },
      dragCallback: function dragCallback(t) {
        N({
          transform: t,
          transition: f.transition,
          isSliding: !1
        }), setTimeout(function () {
          return N(_s(_s({}, S), {
            transition: 0
          }));
        }, 1e3 * f.transition);
      },
      widthCallBack: function widthCallBack(t) {
        M(t), N({
          transform: f.infinite ? v(t, f.navigation ? f.children.length - 1 : f.slide, h.Right) : 0,
          transition: 0,
          isSliding: !1
        });
      }
    })), z.right && t.createElement("div", {
      onClick: function onClick() {
        H(h.Right), f.onRightArrowClick && f.onRightArrowClick();
      },
      ref: F
    }, null !== (a = f.rightArrow) && void 0 !== a ? a : t.createElement(m, {
      direction: "right"
    })), U && t.createElement(E, {
      factory: f.navigation,
      items: f.children,
      current: D,
      onClick: function onClick(t) {
        D !== t && H(t > D ? h.Right : h.Left, t);
      }
    }));
  },
  R = "styles-module_sliderBase__swkx1",
  A = "styles-module_slider__o0fqa",
  M = "styles-module_sliding__3T6T6";
a(".styles-module_sliderBase__swkx1 {\n\twidth: 100%;\n\tposition: relative;\n}\n\n.styles-module_slider__o0fqa {\n\tdisplay: flex;\n\toverflow-x: auto;\n\tscrollbar-width: none; /* Firefox 64 */\n\t-ms-overflow-style: none; /* Internet Explorer 11 */\n}\n\n.styles-module_slider__o0fqa::-webkit-scrollbar {\n\t/** WebKit */\n\tdisplay: none;\n}\n\n.styles-module_slider__o0fqa > * {\n\tflex: 0 0 auto;\n}\n\n.styles-module_sliding__3T6T6 > * {\n\tpointer-events: none;\n}\n");
var T = {
    children: [],
    className: "",
    leftIcon: null,
    rightIcon: null,
    triggerClickOn: 3
  },
  S = function S(e) {
    var i = _s(_s({}, T), e),
      a = i.children,
      l = i.className,
      u = i.leftIcon,
      c = i.rightIcon,
      f = i.triggerClickOn,
      d = n(null),
      m = r(!1),
      g = m[0],
      v = m[1],
      p = r({
        startX: 0,
        scrollLeft: 0
      }),
      w = p[0],
      y = p[1],
      _ = function _() {
        var t = d.current;
        return {
          left: !!t && t.scrollLeft > 0,
          right: !!t && t.scrollWidth > t.scrollLeft + t.offsetWidth
        };
      },
      k = r(_()),
      C = k[0],
      b = k[1],
      L = function L(t) {
        b(_());
      },
      E = o(function (t) {
        null !== t && (Object.defineProperty(d, "current", {
          value: t
        }), b(_()), t.addEventListener("scroll", L));
      }, [d, a]),
      x = function x(t) {
        v(!1), b(_()), d.current.classList.remove(M);
      },
      S = function S(t) {
        var n = function (t) {
            for (var n, e, r = d.current, i = t === h.Left ? r.scrollLeft + r.offsetWidth : r.scrollLeft, o = 0, s = 0, a = Array.from(r.children); s < a.length; s++) {
              var l = a[s],
                u = (n = l, e = void 0, e = getComputedStyle(n), n.offsetWidth + (parseInt(e.marginLeft, 10) || 0) + (parseInt(e.marginRight, 10) || 0));
              if ((o += u) >= i) {
                var c = t === h.Left ? o - i : u;
                return (r.offsetWidth - c) * t;
              }
            }
            return r.offsetWidth;
          }(t),
          e = d.current.scrollLeft;
        N(500, n, e);
      },
      N = function N(t, n, e) {
        for (var r = 0, i = 0; r <= t; i++) window.setTimeout(I, r, i * n / 100 + e), r += t / 100;
      },
      I = function I(t) {
        d.current.scrollLeft = t;
      },
      D = function D(n, e, r) {
        return t.createElement("div", {
          "data-arrow": e,
          onClick: function onClick() {
            return S(n);
          }
        }, null != r ? r : t.createElement("button", null));
      };
    return t.createElement("div", {
      className: R + " " + l,
      "data-testid": "carousel"
    }, C.left && u && D(h.Right, "left", u), C.right && c && D(h.Left, "right", c), t.createElement("div", {
      "data-testid": "sliderList",
      ref: E,
      onMouseDown: function onMouseDown(t) {
        v(!0), y({
          startX: t.pageX - d.current.offsetLeft,
          scrollLeft: d.current.scrollLeft
        });
      },
      onMouseLeave: x,
      onMouseUp: x,
      onMouseMove: function onMouseMove(t) {
        if (g) {
          t.preventDefault();
          var n = t.pageX - d.current.offsetLeft - w.startX;
          Math.abs(n) > f && d.current.classList.add(M), d.current.scrollLeft = w.scrollLeft - n;
        }
      },
      className: A
    }, a));
  };
export { x as Carousel, S as ScrollingCarousel };